import NavigationService from '@lib/NavigationService'

export const navigationSettingPairing = () => {
  NavigationService.navigate('SettingPairing')
}
